function colorToHex(input: string | null | undefined): string {
  const c = (input || '').trim().toLowerCase();
  if (!c) return '#9CA3AF';
  if (c.startsWith('white') || c.startsWith('vit')) return '#FFFFFF';
  if (c.startsWith('yellow') || c.startsWith('gul')) return '#FDE047';
  if (c.startsWith('red') || c.startsWith('röd') || c.startsWith('rod')) return '#EF4444';
  if (c.startsWith('green') || c.startsWith('grön') || c.startsWith('gron')) return '#22C55E';
  if (c.startsWith('blue') || c.startsWith('blå') || c.startsWith('bla')) return '#3B82F6';
  return '#9CA3AF';
}

export function QueenColorIcon({ color, label }: { color: string | null | undefined; label?: string }) {
  const fill = colorToHex(color);
  const stroke = fill === '#FFFFFF' ? '#9CA3AF' : 'none';
  return (
    <span
      title={label || color || ''}
      aria-label={label || color || 'Okänd drottningfärg'}
      className="inline-block align-middle"
      style={{
        width: 12,
        height: 12,
        borderRadius: 999,
        background: fill,
        border: stroke === 'none' ? 'none' : `1px solid ${stroke}`,
      }}
    />
  );
}
